import React, { useEffect } from "react"
import { graphql, PageProps } from "gatsby"

import Layout from "../../components/Layouts/mainPage"
import { NewHeader } from "../../components/Headers/NewHeader"
import { Banner } from "../../components/Banners/HalvaIVkladMedia"
import { FormPKW } from "../../components/FormPKW"
import { NewCalculator } from "../../components/NewCalculator"
import { GridWithTooltip } from "../../components/GridWithTooltip"
import { CARDS_HALVA_I_VKLAD } from "../../components/GridWithTooltip/helper"
import { FourAdvantagesPoints } from "../../components/FourAdvantagesPoints"
import { InstallmentAndDeposit } from "../../components/InstallmentAndDeposit"
import { BottomCta, RefinSeoBgImg } from "../../components/BottomCta"
import { Partners } from "../../components/PartnersNew"
import { Reviews } from "../../components/Reviews"
import { Questions } from "../../components/Questions"
import { NewFooter } from "../../components/NewFooter"

import { getPageData } from "../../helpers/getPageData"

import { PageData } from "../../interfaces/pageProps"
import { QUESTIONS_FOR_HALVA_S_KEHSHBEHKOM } from "../../components/Questions/helpers"
import { useHybridBanner } from "../../hooks/useHybridBanner"
import { HowSteps } from "../../components/HowSteps"
import { STEPS_HALVA_VKLAD_MEDIA } from "../../components/HowSteps/helpers"

const titleForm = (
  <>
    Оформите карту сейчас – <br /> получите подарок!
  </>
)
const bannerTitle = `До +5% к ставке по вкладам с&nbsp;картой Халва`

const subtitleCalculator = (
  <>
    До 10% кешбэка с покупок. <br className="d-sm-none" />
    Воспользуйтесь&nbsp;калькулятором&nbsp;и&nbsp;узнайте, <br className="d-md-none" />
    как вернуть до 60 000₽ в год
  </>
)

const textTooltipCalculator = (
  <>
    Подписка «Халва.Десятка» дает дополнительные преимущества вашей карте. Увеличенная рассрочка* от
    10 месяцев, повышенный кешбек до 10%. Первый месяц подписки – 0 рублей, далее – 399 рублей в
    мес. или 3799 руб. в год (скидка – 20%).
  </>
)

const subTitlePartners = <>Совершайте покупки и&nbsp;участвуйте в&nbsp;розыгрыше ценных призов</>

const GIFT_TITLE = (
  <>
    Оформите Халву и получите
    <br />
    <b>
      {" "}
      месяц&nbsp;подписки
      <br />
      «Халва.Десятка»&nbsp;в&nbsp;подарок.
    </b>
  </>
)

const howStepsWorkTitle = <>Как получить до +5% к ставке по вкладам с картой «Халва»?</>

// Время для таймер(30мин)
const countDownTime = 1800000

export default function Page({ data }: PageProps<PageData>) {
  const { ligal, noIndex } = getPageData(data)

  const banner = useHybridBanner(
    Banner as any,
    { title: bannerTitle, orderNum: "2" },
    { orderNum: "2", variantStyle: "decemberInstallment36months" },
    { orderNum: "2", isDynamicText: true },
    data.allDynamicBanner
  )

  // Получение первой страницы на которую зашел
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])

  return (
    <Layout noHeader noFooter noIndex={noIndex}>
      <NewHeader showHint={false} hasCTA redLogoWithSovcombank />
      <div>{banner}</div>
      <FourAdvantagesPoints
        withTitle
        variant="halvaMedia"
        title="Преимущества с Халвой:"
        orderNum="3"
      />
      <FormPKW
        progressBar
        dataLayerName="shortPersonalForm"
        title={titleForm}
        longTitle
        countDownTime={countDownTime}
        withTimer
        formBtnText="Оформить карту"
        orderNum="4"
        isGreenApprove
      />
      <HowSteps items={STEPS_HALVA_VKLAD_MEDIA} title={howStepsWorkTitle} orderNum="3" />
      <InstallmentAndDeposit orderNum="5" />
      <NewCalculator
        subtitle={subtitleCalculator}
        textTooltip={textTooltipCalculator}
        orderNum="6"
      />
      <Partners
        title="Более 260&nbsp;000 магазинов-партнеров"
        subTitle={subTitlePartners}
        orderNum="7"
      />
      <GridWithTooltip dataContent={CARDS_HALVA_I_VKLAD} orderNum="8" />
      <BottomCta variant="pkwRedesign" title={GIFT_TITLE} BgImg={RefinSeoBgImg} orderNum="9" />
      <Reviews orderNum="10" />
      <Questions questionList={QUESTIONS_FOR_HALVA_S_KEHSHBEHKOM} orderNum="11" />
      <NewFooter ligal={ligal} orderNum="12" />
    </Layout>
  )
}

export const query = graphql`
  query {
    allDynamicBanner {
      edges {
        node {
          name
          deskGatsbyImg {
            url
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                quality: 80
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                breakpoints: [1920, 3840]
              )
            }
          }
          mobGatsbyImg {
            url
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                quality: 80
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                breakpoints: [600, 1200]
              )
            }
          }
        }
      }
    }
    admin {
      page(url: "https://halvacard.ru/order/halva-i-vklad/media/") {
        url
        ligal {
          text
        }
        notIndex
      }
    }
  }
`
